import React from 'react';
import { connect } from 'react-redux';
import ModalConfirmDeleteCase from '../components/modals/ModalConfirmDeleteCase';
import ModalConfirmDiscardChanges from '../components/modals/ModalConfirmDiscardChanges';
import {ModalConfirmActivateCase} from "../components/modals/ModalConfirmActivateCase";
import {
  MODAL_CONFIRM_DISCARD_CHANGES,
  MODAL_CONFIRM_DELETE_CASE,
  MODAL_CONFIRM_ACTIVATE_CASE,
} from '../constants/constants';

const MODAL_COMPONENTS = {
  [MODAL_CONFIRM_DISCARD_CHANGES]: ModalConfirmDiscardChanges,
  [MODAL_CONFIRM_DELETE_CASE]: ModalConfirmDeleteCase,
  [MODAL_CONFIRM_ACTIVATE_CASE]: ModalConfirmActivateCase,
};

const ModalConfirmContainer = (props) => {
  if (!props.modalType) return null;

  const SpecificModal = MODAL_COMPONENTS[props.modalType];

  return <SpecificModal {...props} />;
};

const mapStateToProps = state => state.modal;

export default connect(mapStateToProps, null)(ModalConfirmContainer);
